import {call, put} from "@redux-saga/core/effects";
import deltas from "../../../../redux/actions/deltas";
import request from "../../../helpers/request";
import {getAllPayments} from "../../../../api";
import reloadingPaymentsStates from "../../../../redux/states/reloadingPayments";
import {all, select} from "redux-saga/effects";

const {
    setPayments,
    setReloadingPaymentsState,
    setPaymentsPaginationData,
    setPaymentsGridCurrentPage,
} = deltas.actionCreators;

const {
    LOADING,
    NOT_LOADING,
} = reloadingPaymentsStates;

const options = {
    notificationOnFailure: {
        generateMessage: message => 'There was a problem reloading the data',
    }
};

export default function* reloadPayments(filterChanged = false) {

    if ( filterChanged ) {
        yield put(setPaymentsGridCurrentPage(1));
    }

    const state = yield select();

    let currentPage = state.paymentsGrid.currentPage;

    if (['previous', 'next'].includes(currentPage)) {
        yield put(setPaymentsGridCurrentPage(1));
        currentPage = 1;
    }

    let sorters = [];

    for (const [key, value] of Object.entries(state.paymentsGrid.sorters)) {
        sorters.push([value['column'], value['direction']]);
    }

    const sortersJSON = JSON.stringify(sorters);

    let filters = Object.entries(state.paymentsGrid.filters);

    const filtersJSON = JSON.stringify(filters);

    yield put(setReloadingPaymentsState(LOADING));

    const {
        payments: {response: {data: payments}},
    } = yield all({
        payments: call(request, ...[getAllPayments, options, {}, null, {'sortInstructions':`${sortersJSON}`, 'filterInstructions':`${filtersJSON}`, 'currentPage': `${currentPage}`}]),
    });

    yield put(setPayments(payments.rows));
    yield put(setPaymentsPaginationData({totalPages: payments.totalPages, currentCount: payments.currentCount, totalCount: payments.totalCount}));
    yield put(setReloadingPaymentsState(NOT_LOADING));
}
